const comments = [
  {
    avatar: 'R',
    name: '吃瓜群众甲',
    time: '2小时前',
    content: '这个911爆料网真的太强了！每天早上打开就能看到最新的吃瓜黑料合集，比刷微博效率高多了，再也不怕错过任何一个瓜。',
    likes: 1283,
  },
  {
    avatar: 'M',
    name: '八卦小能手',
    time: '5小时前',
    content: '关注911吃瓜黑料网站已经半年了，内容更新速度真的快，很多热点事件在这里都是首发。吃瓜黑料视频也很清晰，强烈推荐！',
    likes: 956,
  },
  {
    avatar: 'K',
    name: '深夜吃瓜人',
    time: '8小时前',
    content: '作为资深吃瓜群众，911爆料网是我每天必看的站点。最爱的就是他们的爆料合集功能，按事件整理得清清楚楚，回顾起来特别方便。',
    likes: 721,
  },
  {
    avatar: 'L',
    name: '理性吃瓜者',
    time: '1天前',
    content: '相比其他平台的碎片化信息，911爆料吃瓜网的内容整合做得更好。而且有审核机制，不会看到一堆假瓜，这点很重要。',
    likes: 534,
  },
  {
    avatar: 'W',
    name: '吃瓜前线记者',
    time: '1天前',
    content: '从911吃瓜黑料入口进来感觉打开了新世界，信息量大但排版舒服，热门榜单让我快速了解当前最火的爆料事件，非常实用。',
    likes: 312,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              读者<span className="text-primary-500">热评</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              来看看吃瓜群众们怎么说
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {comments.map((comment, idx) => (
              <div
                key={idx}
                className={`bg-background-50 rounded-xl p-5 md:p-6 ${
                  idx === 0 ? 'lg:col-span-2' : ''
                }`}
              >
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-100 text-primary-600 font-bold rounded-full text-sm flex-shrink-0">
                    {comment.avatar}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-2">
                      <span className="text-sm font-bold text-foreground-950">
                        {comment.name}
                      </span>
                      <span className="text-xs text-foreground-400 whitespace-nowrap">
                        {comment.time}
                      </span>
                    </div>
                    <div className="flex items-center gap-1 mt-0.5">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-xs text-accent-500"></i>
                      ))}
                    </div>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  {comment.content}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-thumb-up-line"></i>
                  <span>{comment.likes}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}